
import {Rest, Tasks} from 'utils'
import DatasetSearch from './dataset-search.vue'
import DatasetView from './dataset-view.vue'
import EditablePrompt from './editable-prompt.vue'
import Output from './output.vue'
import PromptSearch from './prompt-search.vue'
import {Splitter, SplitterPanel} from 'primevue'
import {API_PLAYGROUND} from 'consts/api'
import $global from 'stores/global'
import $profile from 'stores/profile'

export default {
  components: {DatasetSearch, PromptSearch, Splitter, SplitterPanel, EditablePrompt, DatasetView, Output},
  data() {
    return {
      rest: new Rest(),
      tasks: new Tasks(),
      prompt_name: undefined,
      dataset_name: undefined,
      prompt_data: undefined,
      dataset_data: undefined,
      output_data: undefined,
      executing: false
    }
  },
  computed: {
    can_execute() {
      return this.prompt_data?.prompt?.length > 0 && this.dataset_data?.length > 0
    }
  },
  async beforeCreate(){
    if (!$profile.is_admin) {
      await $global.goToChats()
      return
    }
  },
  methods: {
    async execute() {
      this.executing = true
      this.output_data = undefined

      const payload = {
        prompt: this.prompt_data.prompt,
        dataset_items: this.dataset_data,
        model: this.prompt_data.config?.model,
        temperature: this.prompt_data.config?.temperature
      }

      const task = await this.rest.post(`${API_PLAYGROUND}/execute`, payload)
      const res = await this.tasks.waitTask(task.id, 1000, (data) => {
        if (data.result && Object.keys(data.result).length > 0)
          this.output_data = data.result?.results
      })
      if (res)
        this.output_data = res.result?.results

      this.executing = false
    },
  }
}

